<nav
	#navigation
	class="z-20 overflow-x-scroll border-b sm:border-b-0 uni-mobile-nav-container"
	aria-label="Tabs"
	id="navigation-tabs"
>
	@if (!postExclusive()) {
		<a
			[routerLink]="['/universities', uniSlug()]"
			[queryParams]="isPreview() ? { preview: 'true' } : {}"
			routerLinkActive="tab-selected-uni-nav"
			[routerLinkActiveOptions]="{ exact: isRouteActive() }"
			class="uni-mobile-nav-button"
		>
			Undergrad<span class="hidden sm:inline-block">uate</span>
		</a>
	}
	<a
		[routerLink]="['/universities', uniSlug(), 'postgraduate']"
		[queryParams]="isPreview() ? { preview: 'true' } : {}"
		routerLinkActive="tab-selected-uni-nav"
		class="uni-mobile-nav-button"
	>
		Postgrad<span class="hidden sm:inline-block">uate</span>
	</a>
	@if (clearingEnabled) {
		<a
			[routerLink]="['/universities', uniSlug(), 'clearing']"
			[queryParams]="isPreview() ? { preview: 'true' } : {}"
			routerLinkActive="tab-selected-uni-nav"
			class="uni-mobile-nav-button"
		>
			<span>Clearing</span>
		</a>
	}
	<a
		[routerLink]="['/universities', uniSlug(), 'open-days']"
		[queryParams]="isPreview() ? { preview: 'true' } : {}"
		routerLinkActive="tab-selected-uni-nav"
		class="uni-mobile-nav-button"
	>
		Open Days
	</a>
	<a
		[routerLink]="['/universities', uniSlug(), 'reviews']"
		[queryParams]="isPreview() ? { preview: 'true' } : {}"
		routerLinkActive="tab-selected-uni-nav"
		class="uni-mobile-nav-button"
	>
		Reviews
	</a>
</nav>
